import { newSaleId } from '@/lib/sales-queue-store'

/**
 * A stable id for this browser install, created on first use.
 *
 * An offline sale is replayed from a device the server has never seen, so the
 * order needs to say which till it came from: that is what lets support trace a
 * late arrival, and what a provisional receipt is numbered against. It survives
 * logout on purpose — it identifies the device, not the person using it — and
 * falls back to a constant rather than throwing when storage is unavailable.
 */
const STORAGE_KEY = 'stockwise:device-id'

export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    if (existing) return existing

    const id = newSaleId()
    localStorage.setItem(STORAGE_KEY, id)
    return id
  } catch {
    // Private mode or a locked-down browser: the sale is still worth capturing.
    return 'unknown-device'
  }
}
